import { render, staticRenderFns } from "./ShowUserRole.vue?vue&type=template&id=e5c7dd9a&scoped=true"
import script from "./ShowUserRole.vue?vue&type=script&lang=js"
export * from "./ShowUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c7dd9a",
  null
  
)

export default component.exports